import { useState, useEffect, useCallback } from "react";
import { registerServiceWorker, skipWaiting } from "../serviceWorkerRegistration";

export function useServiceWorker() {
  const [updateReady,  setUpdateReady]  = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    registerServiceWorker((reg) => {
      setRegistration(reg);
      setUpdateReady(true);
    });
  }, []);

  const applyUpdate = useCallback(() => {
    if (!registration) return;

    // controllerchange fires on navigator.serviceWorker when the new SW takes
    // control of all clients. Reload at that point — not before — so the page
    // always loads under the new SW. The { once } flag prevents a stale
    // listener from firing on a future unrelated SW swap.
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => window.location.reload(),
      { once: true },
    );

    skipWaiting(registration);
  }, [registration]);

  return { updateReady, applyUpdate };
}
